import HTTP_METHOD from "enums/HTTP_METHOD";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";
import useProject from "hooks/useProject";
import IndividualItemResponse from "types/IndividualItemResponse";
import ScriptDto from "types/ScriptDto";

const DEFAULT_PARAMS = {
  includeQuestions: false,
  sort: "title",
  size: 9999,
  page: 0,
};

export default function useCreateOrUpdateScript() {
  const { write, ...rest } = useApiWrite();
  const { projectId } = useProject();

  const createOrUpdateScript = (
    data: Partial<ScriptDto>,
  ): Promise<IndividualItemResponse<ScriptDto>> =>
    write<IndividualItemResponse<ScriptDto>>({
      url: data.id
        ? endpoints.putUpdateScript(projectId, data.id)
        : endpoints.postCreateScript(projectId),
      method: data.id ? HTTP_METHOD.PUT : HTTP_METHOD.POST,
      data,
      mutateOnSuccess: [
        endpoints.getScriptById(projectId, data?.id),
        endpoints.getAllScript(projectId, { ...DEFAULT_PARAMS }),
      ],
    }).then(({ data }) => data);

  return { createOrUpdateScript, ...rest };
}
